function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="69" height="69" viewBox="0 0 69 69" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h69v69H0z" /><path fill="#0275D8" d="M34.5 66A31.53 31.53 0 0 1 3 34.5 31.53 31.53 0 0 1 34.5 3 31.53 31.53 0 0 1 66 34.5 31.53 31.53 0 0 1 34.5 66m0-66A34.54 34.54 0 0 0 0 34.5C0 53.52 15.48 69 34.5 69S69 53.52 69 34.5A34.54 34.54 0 0 0 34.5 0m18 33H36V16.5a1.5 1.5 0 0 0-3 0V33H16.5a1.5 1.5 0 0 0 0 3H33v16.5a1.5 1.5 0 0 0 3 0V36h16.5a1.5 1.5 0 0 0 0-3" /></g></svg>;
});


// WEBPACK FOOTER //
// ./media/svg/icon-add.svg